<template>
  <div>
    <el-form
      :model="form"
      label-width="75px"
      label-position="right"
      :inline="true"
      ref="shopSearchForm"
      size="small"
    >
      <el-form-item label="部门/门店">
        <treeselect
          class="tree-select form-select"
          :default-expand-level="1"
          noOptionsText="暂无选项"
          noResultsText="暂无选项"
          v-model="form.departmentId"
          placeholder="请输入"
          :normalizer="normalizer"
          :options="treedata"
        />
      </el-form-item>
      <el-form-item label="门店简称" prop="storeName">
        <el-input v-model="form.storeName" clearable placeholder="请输入" class="w224"></el-input>
      </el-form-item>
      <el-form-item
        label="分机号"
        prop="extNum"
        :rules="[Validator.checkNumberRange(-1, 65535), Validator.checkIntegerLength()]"
      >
        <el-input
          v-model.number="form.extNum"
          clearable
          placeholder="请输入"
          class="w224"
          maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="search-form" @click="searchForm" size="small"
          >搜索</el-button
        >
        <el-button size="small" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'SearchForm',
  components: {
    Treeselect,
  },
  props: {
    goReset: Boolean,
    treedata: Array,
  },
  data() {
    return {
      form: {
        extNum: '',
        storeName: '', // 门店简称
        departmentId: null,
      },
      date: '',
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        };
      },
      resetTog: false,
    };
  },
  mounted() {
    this.searchForm();
  },
  methods: {
    resetForm() {
      this.resetTog = !this.resetTog;
      this.$refs.shopSearchForm.resetFields();
      this.form.departmentId = null;
      this.searchForm();
    },
    searchForm() {
      this.$refs.shopSearchForm.validate((success) => {
        if (success) this.$emit('searchForm', this.form);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-form {
  margin-left: 17px;
  .tree-select {
    width: 100%;
    display: inline-block;
  }
}
</style>
